// extracted by mini-css-extract-plugin
module.exports = {"companyName":"styles_companyName__2-lF6","bold":"styles_bold__1SvYf","firstName":"styles_firstName__PcZVE"};